
function createFormat () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/create-format/create-format.html?$$REVISION$$'
  }
}
export { createFormat }
